import { useTheme } from "@emotion/react";
import React from "react";

import { Container } from "@brexhq/next/src/components/layout/Container/Container";
import { LinkedLogo } from "@brexhq/next/src/components/navigation/NavBar.elements";
import { Link } from "@brexhq/next/src/components/shared/Link/Link";
import { Icon, ColoredIcon } from "@brexhq/shared/components/deprecated/Icons";

import { SocialIcons } from "./data";
import { IFooterIconLinkGroup } from "./types";

export const FooterIconLinkGroup: React.FC<IFooterIconLinkGroup> = ({
  groupType,
}) => {
  const { colors } = useTheme();

  if (groupType == "brexLogo") {
    return (
      <Container width={{ LRG: "auto", MED: "auto", SML: "100%" }}>
        <LinkedLogo isFooter />
      </Container>
    );
  } else if (groupType === "social") {
    return (
      <Container
        direction="row"
        gap={{
          LRG: "sml",
          MED: "sml",
          SML: "xsml",
        }}
        padding={[0, 0, "xlrg", 0]}
      >
        {SocialIcons.map((socialIcon) => (
          <Link
            key={socialIcon.icon}
            component="footer"
            section="social"
            modifier="unstyled"
            label={socialIcon.icon}
            to={socialIcon.to}
            aria-label={socialIcon.icon}
          >
            <Icon
              width={16}
              height={16}
              icon={socialIcon.icon}
              color={colors.content.inverse.tertiary}
            />
          </Link>
        ))}
      </Container>
    );
  } else if (groupType === "appStore") {
    return (
      <Container display="flex" gap="sml">
        <Link
          to="https://apps.apple.com/us/app/brex/id1472905508"
          modifier="unstyled"
          component="footer"
          section="appstore"
          label="apple"
          aria-label="Download the Brex app from the Apple app store"
        >
          <Icon icon="AppStore" width="71" height="24" />
        </Link>
        <Link
          to="https://play.google.com/store/apps/details?id=com.brex.mobile&hl=en"
          modifier="unstyled"
          component="footer"
          section="appstore"
          label="android"
          aria-label="Download the Brex app from the Google Play store"
        >
          <ColoredIcon icon="Android" width="81" height="24" />
        </Link>
      </Container>
    );
  }
  return <></>;
};
